import { ff } from '@atlassian/jira-feature-flagging';

export const isModernGlobalIssueCreateTriggerEnabled = () =>
	ff('project.config.pce.modern.global-issue-create.trigger', false);

export const isIssueExportControlEnabled = () => ff('dlp-gordian-enabled', false);
